import { BraidPortal, Box } from 'braid-design-system';

import { getMenuPosition, type ALIGNMENT } from './utils/getMenuPosition';

import * as styles from './DropdownMenuItems.css';

interface DropdownMenuProps {
  children: React.ReactNode;
  menuAlignment: ALIGNMENT;
  menuWidth: number;
  onClick: () => void;
  triggerRef?: React.RefObject<HTMLButtonElement> | null;
}

export const DropdownMenuItems = ({
  children,
  menuAlignment = 'BOTTOM_RIGHT',
  menuWidth,
  onClick,
  triggerRef,
}: DropdownMenuProps) => (
  <BraidPortal>
    <Box
      className={styles.layout}
      role="menu"
      zIndex="dropdown"
      onClick={onClick}
      style={{
        width: menuWidth,
        ...getMenuPosition({
          menuWidth,
          menuAlignment,
          triggerPosition: triggerRef?.current?.getBoundingClientRect(),
        }),
      }}
    >
      {children}
    </Box>
  </BraidPortal>
);
